//
import UserModel from '@/models/General/GUser'

//
export default [
    {
        name: 'pch_provider_payment_sheet_state_id',
        type: 'autocomplete',
        props: {
            chips: true,
            items: [
                {
                    text: 'Creado',
                    value: 1,
                },
                {
                    text: 'Autorizado',
                    value: 2,
                },
                {
                    text: 'Rechazado',
                    value: 3,
                },
                {
                    text: 'Pagado',
                    value: 4,
                },
            ],
            label: 'Estado',
            noDataText: 'Sin estados.',
        },
    },
    {
        name: 'g_user_id',
        type: 'autocomplete-model',
        props: {
            chips: true,
            itemText: 'hr_employee_full_name',
            itemValue: 'id',
            label: 'Responsable',
            model: UserModel,
            noDataText: 'Sin usuarios.',
            noObject: true,
        },
    },
    {
        name: 'g_authorizer_user_id',
        type: 'autocomplete-model',
        props: {
            chips: true,
            itemText: 'hr_employee_full_name',
            itemValue: 'id',
            label: 'Supervisor',
            model: UserModel,
            noDataText: 'Sin usuarios.',
            noObject: true,
        },
    },
]
